import React, { useEffect, useState } from "react";
import { Grid, Button, makeStyles, TextField } from "@material-ui/core";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { Pagination } from "react-bootstrap";
import { ProgressBar, Modal } from "react-bootstrap";
import Moment from "moment";
import {
  getMain,
  getBotWeeklyResult,
  getBotScheduleResult,
  findLoginId,
  getMainSys,
  getNoticeAllList,
  getBotMonitoring,
  getBotAdmin,
} from "../modules/api";
import { Line } from "react-chartjs-2";
import { exec } from "apexcharts";
import { da, fi } from "date-fns/locale";
import * as mqtt from "react-paho-mqtt";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export function Main() {
  const classes = useStyles();
  // The first commit of Material-UI
  const [todayTotalExeCount, setTodayTotalExeCount] = useState();
  const [todayTotalExeSuccessCount, setTodayTotalExeSuccessCount] = useState();
  const [exeRate, setExeRate] = useState(0);
  const [todayScheduleList, setTodayScheduleList] = useState([]);
  const [todayScheduleCnt, setTodayScheduleCnt] = useState(0);
  const [todayScheduleListYn, setTodayScheduleListYn] = useState(false);
  const [botList, setBotList] = useState([]);
  const [botList2, setBotList2] = useState([]);
  const [botList3, setBotList3] = useState([]);
  const [noticeAll1, setNoticeAll1] = useState([]);
  const [noticeAll2, setNoticeAll2] = useState([]);
  const [noticeAll3, setNoticeAll3] = useState([]);
  const [botListYn, setBotListYn] = useState(false);
  const [weeklyExeStartDate, setWeeklyExeStartDate] = useState(
    Moment()
      .add(-7, "days")
      .format("YYYY-MM-DD")
  );
  const [weeklyExeEndDate, setWeeklyExeEndDate] = useState(
    Moment(new Date()).format("YYYY-MM-DD")
  );
  const [weeklyScheduleStartDate, setWeeklyScheduleStartDate] = useState(
    Moment()
      .add(-7, "days")
      .format("YYYY-MM-DD")
  );
  const [weeklyScheduleEndDate, setWeeklyScheduleEndDate] = useState(
    Moment(new Date()).format("YYYY-MM-DD")
  );

  const [weeklyDateList, setWeeklyDateList] = useState([]);
  const [weeklyTotalCnt, setWeeklyTotalCnt] = useState([]);
  const [weeklySuccCnt, setWeeklySuccCnt] = useState([]);
  const [weeklyFailCnt, setWeeklyFailCnt] = useState([]);
  const [weeklyExeYn, setWeeklyExeYn] = useState(false);

  const [realTimeDateList, setRealTimeDateList] = useState([]);
  const [realTimeTotalCnt, setRealTimeTotalCnt] = useState([]);
  const [realTimeSuccCnt, setRealTimeSuccCnt] = useState([]);
  const [realTimeFailCnt, setRealTimeFailCnt] = useState([]);
  const [realTimeExeYn, setRealTimeExeYn] = useState(false);

  const [weeklyScheduleDateList, setWeeklyScheduleDateList] = useState([]);
  const [weeklyScheduleTotalCnt, setWeeklyScheduleTotalCnt] = useState([]);
  const [weeklyScheduleSuccCnt, setWeeklyScheduleSuccCnt] = useState([]);
  const [weeklyScheduleFailCnt, setWeeklyScheduleFailCnt] = useState([]);
  const [weeklyScheduleYn, setWeeklyScheduleYn] = useState(false);
  const [botAdminList, setBotAdminList] = useState([]);
  const [isShow1, setIsShow1] = useState(false);
  const [isShow2, setIsShow2] = useState(false);
  const [isShow3, setIsShow3] = useState(false);

  const [execCnt, setExecCnt] = useState(0);
  const [client, setClient] = useState([]);
  const [isFirstExecCnt, setIsFirstExecCnt] = useState(true);
  const [selectLoginId, setSelectLoginId] = useState("");

  let selectedLoginId;
  let selectedLoginNo;
  let c;

  const fetchData = async (value, loginId) => {
    try {
      const role = localStorage.getItem("userRole");
      console.log("role11", role);
      console.log("userno", value);
      // const result = await getMain();
      let result;
      if (role === "SystemAdmin") {
        result = await getMainSys(value);
        const botAdminList = await findLoginId();
        setBotAdminList(botAdminList.data);

        mqtt_exec_list = [];
        mqtt_connect();
      } else {
        result = await getMain();
      }

      //Bot 별 실행 현황
      let botMonitoringList = [];
      let result2;
      if (role === "SystemAdmin") {
        if (
          loginId !== undefined &&
          loginId !== "undefined" &&
          loginId !== ""
        ) {
          setSelectLoginId(loginId);
          selectedLoginId = loginId;

          console.log("===selectedLoginId===", selectedLoginId);
        } else {
          return;
        }
        if (value !== undefined && value !== "undefined" && value !== "") {
          selectedLoginNo = value;

          console.log("===selectedLoginNo===", selectedLoginNo);
        } else {
          return;
        }

        result2 = await getBotMonitoring(value);
      } else {
        if (role === "Bot") {
          result2 = await getBotMonitoring(localStorage.getItem("botAdminNo"));
        } else {
          result2 = await getBotMonitoring(localStorage.getItem("userNo"));
        }
      }

      if (result2.data !== undefined && result2.data.length > 0) {
        result2.data.map((data, index) => {
          if (
            role === "Bot" &&
            data.loginId == localStorage.getItem("userNo")
          ) {
            var obj = new Object();
            obj.idx = index;
            obj.no = data.no;
            obj.botId = data.loginId;
            obj.botAllExeCnt = data.allExeCnt;
            obj.botFailCnt = data.botExeCnt - data.successCnt;
            obj.botExeCnt = data.botExeCnt;
            obj.botExeRate = data.botExeCnt + "/" + data.allExeCnt;
            obj.botAllExeCnt = data.allExeCnt;
            obj.botSuccessCnt = data.successCnt;
            obj.lastDate = data.lastDate
              ? Moment(data.lastDate).format("YYYY-MM-DD HH:mm:ss")
              : "-";
            obj.botStatus = 9;
            obj.botExeName = "-";
            obj.botExeType = 9;
            botMonitoringList.push(obj);
          } else {
            var obj = new Object();
            obj.idx = index;
            obj.no = data.no;
            obj.botId = data.loginId;
            obj.botAllExeCnt = data.allExeCnt;
            obj.botFailCnt = data.botExeCnt - data.successCnt;
            obj.botExeCnt = data.botExeCnt;
            obj.botExeRate = data.botExeCnt + "/" + data.allExeCnt;
            obj.botAllExeCnt = data.allExeCnt;
            obj.botSuccessCnt = data.successCnt;
            obj.lastDate = data.lastDate
              ? Moment(data.lastDate).format("YYYY-MM-DD HH:mm:ss")
              : "-";
            obj.botStatus = 9;
            obj.botExeName = "-";
            obj.botExeType = 9;
            botMonitoringList.push(obj);
          }
        });

        setBotList3(botMonitoringList);
      }

      console.log("getMain11", result);
      setTodayTotalExeCount(
        result.todayTotalExeCount ? result.todayTotalExeCount : 0
      );
      setTodayTotalExeSuccessCount(result.todayTotalExeSuccessCount);
      setExeRate(
        (parseInt(result.todayTotalExeSuccessCount) /
          parseInt(result.todayTotalExeCount)) *
          100
      );

      let scheduleList = [];
      if (result.todayScheduleList.length === 0) {
        setTodayScheduleCnt(0);
        setTodayScheduleListYn(true);
        setTodayScheduleList([]);
      } else {
        //오늘의 예약 건수
        setTodayScheduleCnt(result.todayScheduleList.length);
        setTodayScheduleList(result.todayScheduleList);
        setTodayScheduleListYn(false);
      }
      if (role !== "Bot") {
        setBotList2(result.botList);

        mqtt_sendMessage(result.botList);
      } else {
        setBotList2(result.bot);

        let list = [];

        list.push(result.bot);
        mqtt_sendMessage(list);
      }

      let bot = [];

      if (result.botList !== undefined) {
        if (result.botList.length === 0) {
          setBotListYn(true);
        } else {
          if (result.botList.length < 7) {
            setBotList(result.botList);
          } else {
            for (let i = 0; i < 6; i++) {
              bot.push(result.botList[i]);
            }
            setBotList(bot);
          }
          setBotListYn(false);
        }
      }

      //기간 별 실행 결과 현황
      if (result.weeklyExeCount.length > 0) {
        console.log("1111111");
        getWeekly();
      } else {
        setWeeklyExeYn(false);
        console.log("2222222");
      }

      //실시간 실행 결과 현황

      if (result.todayExeCountByHour.length > 0) {
        let realTimeDateList = [];
        let realTimeSuccCnt = [];
        let realTimeTotalCnt = [];
        let realTimeFailCnt = [];
        result.todayExeCountByHour.map((data, index) => {
          realTimeDateList.push(data.execDate);
          realTimeTotalCnt.push(data.execCnt);
          realTimeSuccCnt.push(data.successCnt);
          realTimeFailCnt.push(data.failCnt);
        });
        setRealTimeDateList(realTimeDateList);
        setRealTimeTotalCnt(realTimeTotalCnt);
        setRealTimeSuccCnt(realTimeSuccCnt);
        setRealTimeFailCnt(realTimeFailCnt);
        setRealTimeExeYn(true);
      } else {
        setRealTimeExeYn(false);
      }

      //기간 별 예약 실행 결과 현황
      if (result.weeklyScheduleExeCount.length > 0) {
        getSchedule();
      } else {
        setWeeklyScheduleYn(false);
      }

      const noticeResult = await getNoticeAllList();
      console.log("noticeResult", noticeResult);
      let noticeList = [];
      if (noticeResult.data.length > 0) {
        noticeResult.data.map((data, index) => {
          const noticeNow = new Date(getToday());
          const noticeStart = new Date(data.startAt);
          const noticeEnd = new Date(data.endAt);
          if (noticeNow >= noticeStart && noticeNow <= noticeEnd) {
            if (role !== "Bot") {
              if (data.viewFor === "all" || data.viewFor === "botAdmin") {
                noticeList.push(data);
              }
            } else {
              if (
                (data.viewFor === "all" || data.viewFor === "bot") &&
                data.user.no == localStorage.getItem("botAdminNo")
              ) {
                noticeList.push(data);
              }
            }
          }
        });
      }
      console.log("noticeList", noticeList.length);
      if (noticeList.length === 1) {
        setNoticeAll1(noticeList[0]);
        setIsShow1(true);
      } else if (noticeList.length === 2) {
        setNoticeAll1(noticeList[0]);
        setNoticeAll2(noticeList[1]);
        setIsShow1(true);
        setIsShow2(true);
      } else if (noticeList.length >= 3) {
        console.log("asdfafs");
        setNoticeAll1(noticeList[0]);
        setNoticeAll2(noticeList[1]);
        setNoticeAll3(noticeList[2]);
        setIsShow1(true);
        setIsShow2(true);
        setIsShow3(true);
      }
    } catch (e) {
      console.log(e);
      // Handle error
    }
  };
  const getToday = () => {
    var date = new Date();
    var year = date.getFullYear();
    var month = ("0" + (1 + date.getMonth())).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);

    return year + "-" + month + "-" + day;
  };

  useEffect(() => {
    console.log("========useEffect==============");
    mqtt_connect();
    fetchData();

    return () => {
      console.log("========useEffect return==============" + selectLoginId);

      if (interval !== undefined) {
        console.log("========clearInterval==============");
        clearInterval(interval);
      }

      if (c !== undefined) {
        try {
          c.disconnect();
          console.log("========mqtt disconnected==============");
        } catch (e) {
          console.log(e);
          // Handle error
        }
      }
    };
  }, [selectLoginId]);

  const mqtt_connect = async () => {
    const role = localStorage.getItem("userRole");

    if (c === undefined) {
      console.log("========mqtt connection==============");
      try {
        c = mqtt.connect(
          "mqtt.laidback.co.kr",
          Number(8883),
          "a" + new Date().getTime(),
          _onConnectionLost,
          _onMessageArrived
        ); // mqtt.connect(host, port, clientId, _onConnectionLost, _onMessageArrived)
      } catch (e) {
        console.log(e);
      }

      if (role !== "SystemAdmin") {
        if (role === "Bot") {
          mqtt_userId = localStorage.getItem("botAdminId");
        } else {
          mqtt_userId = localStorage.getItem("userId");
        }
        console.log("aimily/res/" + mqtt_userId + "/checkStatus");
        c.connect({
          useSSL: true,
          onSuccess: () => {
            console.log("su");
            c.subscribe("aimily/res/" + mqtt_userId + "/checkStatus", _options);
          },
        });
      }

      setClient(c);
    }
  };
  const getWeekly = async () => {
    console.log("weeklyExeStartDate", weeklyExeStartDate);
    console.log("weeklyExeEndDate", weeklyExeEndDate);

    const role = localStorage.getItem("userRole");
    let res;
    if (role === "SystemAdmin") {
      res = await getBotWeeklyResult(
        weeklyExeStartDate,
        weeklyExeEndDate,
        selectedLoginNo
      );
    } else {
      res = await getBotWeeklyResult(weeklyExeStartDate, weeklyExeEndDate);
    }

    console.log("getBotWeeklyResult", res);
    if (res.weeklyExeCount.length > 0) {
      let weeklyOriDateList = [];
      let weeklyDateList = [];
      let weeklySuccCnt = [];
      let weeklyTotalCnt = [];
      let weeklyFailCnt = [];

      res.weeklyExeCount.map((data, index) => {
        weeklyOriDateList.push(data.execDate);
        weeklyDateList.push(data.execDate.substring(8, 10));
        weeklyTotalCnt.push(data.execCnt);
        weeklySuccCnt.push(data.successCnt);
        weeklyFailCnt.push(data.failCnt);
      });

      let weeklyDateList2 = [];
      let weeklySuccCnt2 = [];
      let weeklyTotalCnt2 = [];
      let weeklyFailCnt2 = [];

      //서버에서 0건에 대한 데이터를 주지 않기 때문에 0건에 해당하는 날짜 일 경우 다시 데이터를 다시 넣어줘야함
      var curDate = new Date(weeklyExeStartDate);
      while (curDate <= new Date(weeklyExeEndDate)) {
        console.log("date !!!! " + curDate.toISOString().split("T")[0]);

        if (
          weeklyOriDateList.length > 0 &&
          weeklyOriDateList.includes(curDate.toISOString().split("T")[0])
        ) {
          weeklyDateList2.push(
            curDate
              .toISOString()
              .split("T")[0]
              .substring(8, 10)
          );
          weeklyTotalCnt2.push(
            weeklyTotalCnt[
              weeklyOriDateList.indexOf(curDate.toISOString().split("T")[0])
            ]
          );
          weeklySuccCnt2.push(
            weeklySuccCnt[
              weeklyOriDateList.indexOf(curDate.toISOString().split("T")[0])
            ]
          );
          weeklyFailCnt2.push(
            weeklyFailCnt[
              weeklyOriDateList.indexOf(curDate.toISOString().split("T")[0])
            ]
          );
        } else {
          weeklyDateList2.push(
            curDate
              .toISOString()
              .split("T")[0]
              .substring(8, 10)
          );
          weeklyTotalCnt2.push(0);
          weeklySuccCnt2.push(0);
          weeklyFailCnt2.push(0);
        }

        curDate.setDate(curDate.getDate() + 1);
      }

      setWeeklyDateList(weeklyDateList2);
      setWeeklyTotalCnt(weeklyTotalCnt2);
      setWeeklySuccCnt(weeklySuccCnt2);
      setWeeklyFailCnt(weeklyFailCnt2);
      setWeeklyExeYn(true);
    } else {
      setWeeklyExeYn(false);
    }
  };

  const getSchedule = async () => {
    const role = localStorage.getItem("userRole");
    let res;
    if (role === "SystemAdmin") {
      res = await getBotScheduleResult(
        weeklyExeStartDate,
        weeklyExeEndDate,
        selectedLoginNo
      );
    } else {
      res = await getBotScheduleResult(weeklyExeStartDate, weeklyExeEndDate);
    }

    console.log("getSchedule", res.weeklyScheduleExeCount);
    if (res.weeklyScheduleExeCount.length > 0) {
      let weeklyOriDateList = [];
      let weeklyScheduleDateList = [];
      let weeklyScheduleSuccCnt = [];
      let weeklyScheduleTotalCnt = [];
      let weeklyScheduleFailCnt = [];

      res.weeklyScheduleExeCount.map((data, index) => {
        weeklyOriDateList.push(data.execDate);
        weeklyScheduleDateList.push(data.execDate.substring(8, 10));
        weeklyScheduleTotalCnt.push(data.execCnt);
        weeklyScheduleSuccCnt.push(data.successCnt);
        weeklyScheduleFailCnt.push(data.failCnt);
      });

      let weeklyScheduleDateList2 = [];
      let weeklyScheduleSuccCnt2 = [];
      let weeklyScheduleTotalCnt2 = [];
      let weeklyScheduleFailCnt2 = [];

      //서버에서 0건에 대한 데이터를 주지 않기 때문에 0건에 해당하는 날짜 일 경우 다시 데이터를 다시 넣어줘야함
      var curDate = new Date(weeklyScheduleStartDate);
      while (curDate <= new Date(weeklyScheduleEndDate)) {
        console.log("date !!!! " + curDate.toISOString().split("T")[0]);

        if (
          weeklyOriDateList.length > 0 &&
          weeklyOriDateList.includes(curDate.toISOString().split("T")[0])
        ) {
          weeklyScheduleDateList2.push(
            curDate
              .toISOString()
              .split("T")[0]
              .substring(8, 10)
          );
          weeklyScheduleSuccCnt2.push(
            weeklyScheduleSuccCnt[
              weeklyOriDateList.indexOf(curDate.toISOString().split("T")[0])
            ]
          );
          weeklyScheduleTotalCnt2.push(
            weeklyScheduleTotalCnt[
              weeklyOriDateList.indexOf(curDate.toISOString().split("T")[0])
            ]
          );
          weeklyScheduleFailCnt2.push(
            weeklyScheduleFailCnt[
              weeklyOriDateList.indexOf(curDate.toISOString().split("T")[0])
            ]
          );
        } else {
          weeklyScheduleDateList2.push(
            curDate
              .toISOString()
              .split("T")[0]
              .substring(8, 10)
          );
          weeklyScheduleSuccCnt2.push(0);
          weeklyScheduleTotalCnt2.push(0);
          weeklyScheduleFailCnt2.push(0);
        }

        curDate.setDate(curDate.getDate() + 1);
      }

      setWeeklyScheduleDateList(weeklyScheduleDateList2);
      setWeeklyScheduleTotalCnt(weeklyScheduleTotalCnt2);
      setWeeklyScheduleSuccCnt(weeklyScheduleSuccCnt2);
      setWeeklyScheduleFailCnt(weeklyScheduleFailCnt2);

      setWeeklyScheduleYn(true);
    } else {
      setWeeklyScheduleYn(false);
    }
  };

  const handleWeeklyStartDateChange = (e) => {
    setWeeklyExeStartDate(e.target.value);
  };
  const handleWeeklyEndDateChange = (e) => {
    setWeeklyExeEndDate(e.target.value);
  };
  const handleScheduleStartDateChange = (e) => {
    setWeeklyScheduleStartDate(e.target.value);
  };
  const handleScheduleEndDateChange = (e) => {
    setWeeklyScheduleEndDate(e.target.value);
  };

  let today = new Date();
  let date =
    today.getFullYear() +
    "-" +
    (("0" + (1 + today.getMonth())).slice(-2) + 1) +
    "-" +
    ("0" + today.getDate()).slice(-2);
  console.log("todayScheduleList", todayScheduleList);
  const toDoList = todayScheduleList.map((data, index) => {
    let exeText;
    let exeClass;
    if (data.status === 0) {
      exeText = "미실행";
      exeClass = "label-secondary";
    } else if (data.status === 1) {
      exeText = "성공";
      exeClass = "label-success";
    } else {
      exeText = "실패";
      exeClass = "label-primary";
    }

    return (
      <tr>
        <td className="text-left">
          예약시간{" "}
          {data.startTime.substring(0, 2) + ":" + data.startTime.substring(2)}
        </td>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {data.scheduleName}
        </td>
        <td className="text-right">
          <span className={"label label-xl label-inline " + exeClass}>
            {exeText}
          </span>
        </td>
      </tr>
    );
  });

  const botRate = botList3.map((data, index) => {
    let exeRate = 0;
    if (parseInt(data.botExeCnt) != 0 && parseInt(data.botAllExeCnt) != 0) {
      exeRate = parseInt(
        (parseInt(data.botExeCnt) / parseInt(data.botAllExeCnt)) * 100
      );
    }

    return (
      <li className="mb-5">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <p className="mb-0 text-left">{data.botId}</p>
          <small className="mb-1 d-flex text-gray">
            {exeRate}%({data.botExeRate})
          </small>
        </div>
        <div className="progress-wrap d-flex align-items-center justify-content-between">
          <div className="progress progress-xs w-100">
            <div
              className="progress-bar bg-danger"
              role="progressbar"
              style={{ width: exeRate + "%" }}
              aria-valuenow={data.botExeCnt}
              aria-valuemin="0"
              aria-valuemax={data.botAllExeCnt}
            ></div>
          </div>
        </div>
      </li>
    );
  });

  const toggleShow1 = () => {
    setIsShow1(!isShow1);
  };
  const toggleShow2 = () => {
    setIsShow2(!isShow2);
  };
  const toggleShow3 = () => {
    setIsShow3(!isShow3);
  };

  let mqtt_list;
  let mqtt_userId;
  let mqtt_exec_list;
  let interval;
  const mqtt_sendMessage = (monitorList) => {
    console.log("========start==============");

    if (monitorList !== undefined && monitorList.length > 0) {
      if (monitorList.length > 0 && c !== undefined) {
        const role = localStorage.getItem("userRole");
        if (
          role === "SystemAdmin" &&
          selectedLoginId !== undefined &&
          selectedLoginId !== "" &&
          selectedLoginId !== "undefined"
        ) {
          console.log("selectedLoginId :: " + selectedLoginId);
          console.log("selectedLoginId typeof :: " + typeof selectedLoginId);
          c.connect({
            useSSL: true,
            onSuccess: () => {
              console.log("su");
              c.subscribe(
                "aimily/res/" + selectedLoginId + "/checkStatus",
                _options
              );
            },
          });

          console.log(
            "==========selectedLoginId=============",
            selectedLoginId
          );
        }

        console.log("====_onSendMessage======");
        try {
          //일단 초기화
          setExecCnt(0);
          // mqtt_cnt = 0;
          mqtt_list = [...monitorList];
          mqtt_exec_list = [];
          interval = setInterval(async () => {
            _onSendMessage(c);

            setTimeout(function() {
              setExecCnt(mqtt_exec_list.length);
              mqtt_exec_list = [];
              if (isFirstExecCnt) setIsFirstExecCnt(false);
            }, 1000);
          }, 4000);
        } catch (e) {
          setExecCnt(0);
          console.log("send message error", e);
        }
      }
    } else {
      setExecCnt(0);
    }
  };
  const _options = {};

  const _onConnectionLost = () => {};
  const _onMessageArrived = (message) => {
    console.log("====_onMessageArrived======");

    if (message.topic.indexOf("checkStatus") > -1) {
      console.log(message.payloadString);
      const json = JSON.parse(message.payloadString);
      const data = json.data;
      console.log(data.loginId, data);

      mqtt_list.map((item, index) => {
        if (item.loginId === data.loginId && data.status == 2) {
          console.log("====loginId!!!!======", item.loginId);
          mqtt_exec_list.push(item.loginId);
          console.log("====mqtt_cnt!!!!======", mqtt_exec_list.length);
        }
      });
    }
  };

  const _onSendMessage = (c) => {
    console.log("====_onSendMessage start======");
    // console.log(client);
    const jsonMessage = {
      trId: Math.random()
        .toString(36)
        .substr(2, 10),
    };

    const role = localStorage.getItem("userRole");
    if (role !== "SystemAdmin") {
      const message = mqtt.parsePayload(
        "aimily/req/" + mqtt_userId + "/checkStatus",
        JSON.stringify(jsonMessage)
      );
      try {
        console.log("====send start======");
        c.send(message);
        console.log("====send end======");
      } catch (e) {
        console.log("send message error", e);
      }
    } else {
      const message = mqtt.parsePayload(
        "aimily/req/" + selectedLoginId + "/checkStatus",
        JSON.stringify(jsonMessage)
      );
      console.log("selectedLoginId", selectedLoginId);
      c.send(message);
    }
    console.log("====_onSendMessage end======");
  };

  return (
    <div>
      <Modal show={isShow1}>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">공지사항</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <span>{noticeAll1.title}</span>
          <br />
          <span>{noticeAll1.contents}</span>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleShow1}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={isShow2}>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">공지사항</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <span>{noticeAll2.title}</span>
          <br />
          <span>{noticeAll2.contents}</span>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleShow2}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={isShow3}>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">공지사항</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <span>{noticeAll3.title}</span>
          <br />
          <span>{noticeAll3.contents}</span>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleShow3}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <div
        className="d-flex align-items-center justify-content-between w-100"
        style={{ marginTop: 30 }}
      >
        <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
          대시보드
        </h3>
        {localStorage.getItem("userRole") === "SystemAdmin" && (
          <div className="fv-plugins-icon-container mr-5">
            <select
              className="form-control form-control-lg form-control-solid"
              style={{ borderColor: "black", width: "200px" }}
              name="botAdminList"
              onChange={(e) =>
                fetchData(e.target.value, e.target.selectedOptions[0].text)
              }
            >
              <option value="">선택</option>
              {botAdminList &&
                botAdminList.length > 0 &&
                botAdminList.map((data, index) => {
                  return <option value={data.no}>{data.loginId}</option>;
                })}
            </select>
          </div>
        )}
      </div>
      <div id="pageid22" style={{ marginTop: 50 }}>
        <div className="row dashboard-top-btn-row justify-content-between">
          <div className="col-xl-3 gutter-b">
            <Link href="/PageId30">
              <Button
                className={`btn font-weight-bold text-white px-9 py-7 w-100 justify-content-between`}
              >
                <div className="text text-left">
                  <h1>{todayTotalExeCount}</h1>
                  <h6 className="mb-0">실행건수</h6>
                </div>
                <div className="icon">
                  <span className="svg-icon svg-icon-xxl">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Home/Book.svg")}
                    />
                  </span>
                </div>
              </Button>
            </Link>
          </div>
          <div className="col-xl-3 gutter-b">
            <Link href="/PageId30">
              <Button
                className={`btn font-weight-bold text-white px-9 py-7 w-100 justify-content-between`}
              >
                <div className="text text-left">
                  <h1>{Math.round(isNaN(exeRate) ? 0 : exeRate)}</h1>
                  <h6 className="mb-0">실행 성공률</h6>
                </div>
                <div className="icon">
                  <span className="svg-icon svg-icon-xxl">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Navigation/Angle-double-right.svg"
                      )}
                    />
                  </span>
                </div>
              </Button>
            </Link>
          </div>
          <div className="col-xl-3 gutter-b">
            <Link href="/PageId25">
              <Button
                className={`btn font-weight-bold text-white px-9 py-7 w-100 justify-content-between`}
              >
                <div className="text text-left">
                  <h1>{todayScheduleCnt}</h1>
                  <h6 className="mb-0">예약건수</h6>
                </div>
                <div className="icon">
                  <span className="svg-icon svg-icon-xxl">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Communication/Write.svg"
                      )}
                    />
                  </span>
                </div>
              </Button>
            </Link>
          </div>

          <div className="col-xl-3 gutter-b">
            {localStorage.getItem("userRole") !== "Bot" && (
              <Link href="/PageId31">
                <Button
                  className={`btn font-weight-bold text-white px-9 py-7 w-100 justify-content-between`}
                >
                  <div className="text text-left">
                    <h1>{botList2.length}</h1>
                    <h6 className="mb-0">전체 Bot 수</h6>
                  </div>
                  <div className="icon">
                    <span className="svg-icon svg-icon-xxl">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Electric/Gas-stove.svg"
                        )}
                      />
                    </span>
                  </div>
                </Button>
              </Link>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-xl-4">
            <div className="card card-custom gutter-b card-stretch">
              <div className="card-header border-0 pt-5">
                <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
                  현재 Bot 실행 현황
                </h3>
              </div>
              {localStorage.getItem("userRole") !== "Bot" && (
                <div className="card-body align-items-center d-flex justify-content-center flex-column">
                  {isFirstExecCnt ? (
                    <p>Bot상태를 불러오는 중입니다...</p>
                  ) : (
                    <div style={{ textAlign: "-webkit-center" }}>
                      <h1 className="mb-7">
                        {execCnt}/{botList2.length}
                      </h1>
                      <p>
                        현재 {botList2.length}bot 중에 {execCnt}bot이
                        실행중입니다.
                      </p>
                    </div>
                  )}

                  <div className="more-info">
                    <Link to="/botMonitoring" className="text-primary">
                      More info
                    </Link>
                  </div>
                </div>
              )}
              {localStorage.getItem("userRole") === "Bot" && (
                <div className="card-body align-items-center d-flex justify-content-center flex-column">
                  {execCnt == 0 ? (
                    <p>현재 {botList2.loginId} Bot이 미 실행중입니다.</p>
                  ) : (
                    <p>현재 {botList2.loginId} Bot이 실행중입니다.</p>
                  )}

                  <div className="more-info">
                    <Link to="/botMonitoring" className="text-primary">
                      More info
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-4">
            <div className="card card-custom gutter-b card-stretch">
              <div className="card-header border-0 pt-5">
                <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
                  기간 별 실행 결과 현황
                </h3>
                <p className="d-flex align-items-center mb-0">단위 : 건</p>
              </div>
              <div className="card-body align-items-center d-flex justify-content-center flex-column">
                <div className="d-flex">
                  <form className={classes.container} noValidate>
                    <TextField
                      id="date"
                      type="date"
                      style={{ width: "130px" }}
                      defaultValue={weeklyExeStartDate}
                      onChange={(e) => handleWeeklyStartDateChange(e)}
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </form>
                  <span> ~ </span>
                  <form className={classes.container} noValidate>
                    <TextField
                      id="date"
                      type="date"
                      style={{ width: "130px" }}
                      defaultValue={weeklyExeEndDate}
                      onChange={(e) => handleWeeklyEndDateChange(e)}
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </form>
                  <Button
                    onClick={() => getWeekly()}
                    style={{ marginLeft: "5px" }}
                    className={`btn btn-info font-weight-bold text-white`}
                  >
                    검색
                  </Button>
                </div>
                <div style={{ marginTop: "25px" }}>
                  {!weeklyExeYn && (
                    <div style={{ marginTop: "5px" }}>
                      실행 내역이 없습니다.
                    </div>
                  )}
                  {weeklyExeYn && (
                    <Line
                      data={{
                        labels: weeklyDateList,
                        datasets: [
                          {
                            label: "전체",
                            data: weeklyTotalCnt,
                            fill: false,
                            backgroundColor: "rgb(192,192,192)",
                            borderColor: "rgb(192,192,192)",
                            tension: 0.5,
                          },
                          {
                            label: "성공",
                            data: weeklySuccCnt,
                            fill: false,
                            backgroundColor: "rgb(90, 181, 2)",
                            borderColor: "rgb(90, 181, 2)",
                            tension: 0.5,
                          },
                          {
                            label: "실패",
                            data: weeklyFailCnt,
                            fill: false,
                            backgroundColor: "#ff6f5e",
                            borderColor: "#ff6f5e",
                            tension: 0.5,
                          },
                        ],
                      }}
                      height={200}
                      width={350}
                      options={{
                        maintainAspectRatio: false,
                        scales: {
                          y: {
                            min: 0,
                            ticks: {
                              stepSize: 1,
                            },
                          },
                        },
                        plugins: {
                          legend: {
                            position: "bottom",
                          },
                        },
                      }}
                    />
                  )}
                </div>
                <div className="more-info">
                  <Link to="/botWeekly" className="text-primary">
                    More info
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4">
            <div className="card card-custom gutter-b card-stretch">
              <div className="card-header border-0 pt-5">
                <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
                  오늘 예약 작업 리스트
                </h3>
              </div>
              <div
                className="card-body align-items-center d-flex justify-content-center flex-column"
                style={{ paddingRight: "0px" }}
              >
                {todayScheduleListYn && (
                  <table className="w-100 reservation-table">
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          예약 작업이 없습니다.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
                {!todayScheduleListYn && (
                  <div
                    style={{
                      position: "relative",
                      height: "300px",
                      overflowY: "auto",
                      paddingRight: "20px",
                    }}
                  >
                    <table className="w-100 reservation-table">
                      <tbody>{toDoList}</tbody>
                    </table>
                  </div>
                )}

                <div className="more-info">
                  <Link to="/schedule" className="text-primary">
                    More info
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-4">
            <div className="card card-custom gutter-b card-stretch">
              <div className="card-header border-0 pt-5">
                <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
                  오늘 Bot 별 실행률 현황
                </h3>
                <p className="d-flex align-items-center mb-0">단위 : %(건)</p>
              </div>
              <div
                className="card-body align-items-center d-flex justify-content-center flex-column"
                style={{ paddingRight: "0px" }}
              >
                {botListYn && (
                  <ul className="w-100 pl-0">
                    <div style={{ textAlign: "center" }}>
                      실행 내역이 없습니다.
                    </div>
                  </ul>
                )}
                {!botListYn && (
                  <div
                    style={{
                      position: "relative",
                      height: "300px",
                      overflowY: "auto",
                      paddingRight: "20px",
                      width: "100%",
                    }}
                  >
                    <ul className="w-100 pl-0">{botRate}</ul>
                  </div>
                )}

                {/* <div className="d-flex flex-center mt-5">
									<Pagination>
										<Pagination.Prev />

										<Pagination.Item>{1}</Pagination.Item>
										<Pagination.Item>{2}</Pagination.Item>
										<Pagination.Item active>{3}</Pagination.Item>
										<Pagination.Item disabled>{4}</Pagination.Item>
										<Pagination.Item>{5}</Pagination.Item>

										<Pagination.Next />
									</Pagination>
								</div> */}
                <div className="more-info">
                  <Link to="/botMonitoring" className="text-primary">
                    More info
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4">
            <div className="card card-custom gutter-b card-stretch">
              <div className="card-header border-0 pt-5">
                <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
                  실시간 실행 결과 현황
                </h3>
                <p className="d-flex align-items-center mb-0">단위 : 시간</p>
              </div>
              <div className="card-body align-items-center d-flex justify-content-center flex-column">
                <div style={{ marginTop: "25px" }}>
                  {!realTimeExeYn && (
                    <div style={{ marginTop: "5px" }}>
                      실행 내역이 없습니다.
                    </div>
                  )}
                  {realTimeExeYn && (
                    <Line
                      data={{
                        labels: realTimeDateList,
                        datasets: [
                          {
                            label: "전체",
                            data: realTimeTotalCnt,
                            fill: false,
                            backgroundColor: "rgb(192,192,192)",
                            borderColor: "rgb(192,192,192)",
                            tension: 0.5,
                          },
                          {
                            label: "성공",
                            data: realTimeSuccCnt,
                            fill: false,
                            backgroundColor: "rgb(90, 181, 2)",
                            borderColor: "rgb(90, 181, 2)",
                            tension: 0.5,
                          },
                          {
                            label: "실패",
                            data: realTimeFailCnt,
                            fill: false,
                            backgroundColor: "#ff6f5e",
                            borderColor: "#ff6f5e",
                            tension: 0.5,
                          },
                        ],
                      }}
                      height={200}
                      width={350}
                      options={{
                        maintainAspectRatio: false,
                        scales: {
                          y: {
                            min: 0,
                            ticks: {
                              stepSize: 1,
                            },
                          },
                        },
                        plugins: {
                          legend: {
                            position: "bottom",
                          },
                        },
                      }}
                    />
                  )}
                </div>
                <div className="more-info">
                  <Link to="/botRate" className="text-primary">
                    More info
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4">
            <div className="card card-custom gutter-b card-stretch">
              <div className="card-header border-0 pt-5">
                <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
                  기간 별 예약 실행 결과 현황
                </h3>
                <p className="d-flex align-items-center mb-0">단위 : 건</p>
              </div>
              <div className="card-body align-items-center d-flex justify-content-center flex-column">
                <div className="d-flex">
                  <form className={classes.container} noValidate>
                    <TextField
                      id="date"
                      type="date"
                      style={{ width: "130px" }}
                      defaultValue={weeklyScheduleStartDate}
                      onChange={(e) => handleScheduleStartDateChange(e)}
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </form>
                  <span> ~ </span>
                  <form className={classes.container} noValidate>
                    <TextField
                      id="date"
                      type="date"
                      style={{ width: "130px" }}
                      defaultValue={weeklyScheduleEndDate}
                      onChange={(e) => handleScheduleEndDateChange(e)}
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </form>
                  <Button
                    onClick={() => getSchedule()}
                    style={{ marginLeft: "5px" }}
                    className={`btn btn-info font-weight-bold text-white`}
                  >
                    검색
                  </Button>
                </div>
                <div style={{ marginTop: "25px" }}>
                  {!weeklyScheduleYn && (
                    <div style={{ marginTop: "5px" }}>
                      실행 내역이 없습니다.
                    </div>
                  )}
                  {weeklyScheduleYn && (
                    <Line
                      data={{
                        labels: weeklyScheduleDateList,
                        datasets: [
                          {
                            label: "전체",
                            data: weeklyScheduleTotalCnt,
                            fill: false,
                            backgroundColor: "rgb(192,192,192)",
                            borderColor: "rgb(192,192,192)",
                            tension: 0.5,
                          },
                          {
                            label: "성공",
                            data: weeklyScheduleSuccCnt,
                            fill: false,
                            backgroundColor: "rgb(90, 181, 2)",
                            borderColor: "rgb(90, 181, 2)",
                            tension: 0.5,
                          },
                          {
                            label: "실패",
                            data: weeklyScheduleFailCnt,
                            fill: false,
                            backgroundColor: "#ff6f5e",
                            borderColor: "#ff6f5e",
                            tension: 0.5,
                          },
                        ],
                      }}
                      height={200}
                      width={350}
                      options={{
                        maintainAspectRatio: false,
                        scales: {
                          y: {
                            min: 0,
                            ticks: {
                              stepSize: 1,
                            },
                          },
                        },
                        plugins: {
                          legend: {
                            position: "bottom",
                          },
                        },
                      }}
                    />
                  )}
                </div>
                <div className="more-info">
                  <Link to="/botWeekly" className="text-primary">
                    More info
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
